import { Component, Host, h, Prop } from '@stencil/core';
import { ButtonAppearance, ButtonType } from '../rcm-button/rcm-button.types';

@Component({
  tag: 'rcm-contact-button',
  styleUrl: 'rcm-contact-button.scss',
  shadow: true,
})
export class RcmContactButton {
  @Prop() link: string;

  @Prop() name: string;

  render() {
    return (
      <Host>
        <div class="container">
          <rcm-button
            text={this.name}
            icon="message-circle"
            type={ButtonType.BUTTON}
            appearance={ButtonAppearance.PRIMARY_YELLOW}
            link={this.link}
            parentComponent="rcm-contact-button"
          ></rcm-button>
        </div>
      </Host>
    );
  }
}
